import { Type } from 'class-transformer';
import { ArrayMaxSize, ArrayNotEmpty, IsArray, ValidateNested } from 'class-validator';
import { OrderCopyTargetDto } from './order-copy-target.dto';

const MAX_ACCOUNTS = 10;

/**
 * DTO the represents the payload for order copy
 */
export class OrderCopyRequestDto {
  @IsArray()
  @ArrayNotEmpty()
  @ArrayMaxSize(MAX_ACCOUNTS)
  @ValidateNested({ each: true })
  @Type(() => OrderCopyTargetDto)
  targets: OrderCopyTargetDto[];
}
